<template>
  <li role="presentation">
    <button type="button"
      class="dropdown-item"
      role="menuitem"
      v-on:click="onClick"><slot></slot></button>
  </li>
</template>

<script>
// Élément-bouton de <bs-dropdown> : émet click puis ferme le menu.
export default {
  name: 'BsDropdownItemButton',
  inject: {
    bsDropdown: { default: null },
  },
  emits: ['click'],
  methods: {
    onClick(event) {
      this.$emit('click', event);
      if (this.bsDropdown) {
        this.bsDropdown.hide(true);
      }
    },
  },
};
</script>
